













































import { defineComponent, computed, ref, Ref } from '@vue/composition-api';

import nameEdit from '@/renderer/components/user/components/nameEdit.vue';
import phoneEdit from '@/renderer/components/user/components/phoneEdit.vue';
import passwordEdit from '@/renderer/components/user/components/passwordEdit.vue';
import SpaceIntroduce from '@/renderer/components/user/components/SpaceIntroduce.vue';

import i18n, { i18n_t } from '@/locales/i18n';
import { openDevTools, phoneCompose } from '@/renderer/scripts/utils/tools';

import { ShowWitchEditType } from '@/renderer/components/user/compositions/userConfigHandler';

type NameEditCtx = InstanceType<typeof nameEdit>;
type PhoneEditCtx = InstanceType<typeof phoneEdit>;
export default defineComponent({
  components: {
    SpaceIntroduce,
    nameEdit,
    phoneEdit,
    passwordEdit,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    editType: {
      type: String as () => ShowWitchEditType,
      required: true,
      default: ShowWitchEditType.none,
    },
  },
  setup(props, context) {
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const showEditType = computed(() => props.editType);
    const showWitchEdit: Ref<ShowWitchEditType> = ref(showEditType.value);
    const store = context.root.$store;

    const nicknameEditRef: Ref<NameEditCtx | null> = ref(null);
    const phoneEditRef: Ref<PhoneEditCtx | null> = ref(null);
    const passwordEditRef: Ref<PhoneEditCtx | null> = ref(null);

    const isSaveDisabled = ref(false);
    const editingPassword = computed(
      () => showWitchEdit.value === ShowWitchEditType.password || showWitchEdit.value === ShowWitchEditType.space,
    );

    const headerMap = {
      none: i18n_t('个人设置'),
      nickname: i18n_t('修改昵称'),
      phone: i18n_t('更换手机号'),
      email: i18n_t('更换邮箱'),
      password: i18n_t('修改密码'),
      space: i18n_t('空间使用说明'),
    };
    const headerTitle = computed(() => headerMap[showEditType.value]);
    const userNickname = computed(() => store.getters.userBaseInfo.nickname);
    const userPhoneNumber = computed(() =>
      phoneCompose(store.getters.userBaseInfo.countryCode, store.getters.userBaseInfo.phoneNumber),
    );

    const isEditing = computed(() => {
      const value = showWitchEdit.value !== ShowWitchEditType.none;
      if (!value) {
        isSaveDisabled.value = false;
        methods.handleClose();
      }
      return value;
    });
    const showFoot = computed(() => {
      return showEditType.value !== ShowWitchEditType.space && showEditType.value !== ShowWitchEditType.password;
    });
    const methods = {
      handleClose() {
        context.emit('close');
      },
      handleOpen() {
        showWitchEdit.value = props.editType;
      },

      onSave() {
        if (!isEditing.value) return;
        // 修改昵称
        if (showEditType.value === ShowWitchEditType.nickname && nicknameEditRef.value) {
          nicknameEditRef.value.onSubmit();
          return;
        }
        // 修改手机号
        if (showEditType.value === ShowWitchEditType.phone && phoneEditRef.value) {
          phoneEditRef.value.onSubmit();
        }
        // 修改密码
        if (showEditType.value === ShowWitchEditType.password && passwordEditRef.value) {
          passwordEditRef.value.onSubmit();
        }
      },
    };
    return {
      showFoot,
      editingPassword,
      innerShow,
      ShowWitchEditType,
      showWitchEdit,
      headerTitle,
      userNickname,
      userPhoneNumber,
      ...methods,
      nicknameEditRef,
      phoneEditRef,
      isSaveDisabled,
      showEditType,
    };
  },
});
